import { render } from "./App.vue?vue&type=template&id=f963bbdc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f963bbdc&lang=css"

import exportComponent from "C:\\Users\\Wallace\\Documents\\Cursos\\Vue\\composition-api\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__